import { gql, useMutation } from "@apollo/client";
import type { UserAccessLevel } from "@/types";

const UPDATE_USER = gql`
  mutation UpdateUser($input: UserUpdateInput!) {
    updateUser(input: $input) {
      success
      message
      user {
        id
        email
        firstName
        lastName
        accessLevel
        congridUserId
        sitedriveUserId
      }
    }
  }
`;

export interface UpdateUserInput {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  title?: string | null;
  accessLevel?: UserAccessLevel | null;
  congridUserId?: string | null;
  sitedriveUserId?: string | null;
}

export function useUpdateUser() {
  const [mutate, { loading, error }] = useMutation(UPDATE_USER, {
    refetchQueries: ["GetUsers"],
  });

  const updateUser = async (input: UpdateUserInput) => {
    const { data } = await mutate({ variables: { input } });
    return data?.updateUser;
  };

  return { updateUser, loading, error };
}
